import { api } from '@/fsd/shared/api';
import { IReconciliation } from '../model/types';
import { IApiPaginatedResponse } from '@/fsd/shared/api/types';

export const getReconciliations = ({
  filters = {},
  sorted,
  page,
  limit,
}: {
  filters?: Record<string, any>;
  sorted?: string[];
  page?: number;
  limit?: number;
}) => {
  return api.post<IApiPaginatedResponse<IReconciliation[]>>(
    '/api/v1/reconciliation/',
    {
      body: {
        filters,
        sorted: sorted?.length === 0 ? undefined : sorted,
        page,
        limit,
      },
    }
  );
};
